



















import { defineComponent } from "@vue/composition-api";
import { Icon2 } from "@micad/vue-components";

export default defineComponent({
  components: {
    Icon2,
  },
  props: {
    length: Number,
  },
});
